import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import ButtonMakeApi from './PropertiesPaneButtonMakeApi.jsx'

const PropertiesPaneAlg = (props) => (
    <PropertiesPane
        buttons={
            <>
                <ButtonMakeApi />
            </>
        }

        {...props}
    />
)

export default PropertiesPaneAlg
